const hasChosenFieldOptions = (options?: { [x: string]: unknown }) => {
  return options && Object.keys(options).some(k => !!options[k])
}

export default hasChosenFieldOptions
